/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import FavoritesOverview from './components/FavoritesOverview';

/* utilities */
import { parseDataToProps } from '~/utilities';

const FavoritesToggleNodes = Array.from(document.querySelectorAll("[data-favorites-overview]"));
[...FavoritesToggleNodes].forEach((node) => render(<FavoritesOverview {...parseDataToProps(node.dataset)} />, node));
